const ContentVisibility = `
  fragment ContentVisibility on ContentVisibility {
    status
    workflowState
  }
`
export default ContentVisibility
